<div class="current-working-project">
  <div class="chart-wrapper">
    <ngx-charts-bar-vertical
      [results]="currentWorkingProjectData.chartData"
      [xAxis]="true"
      [yAxis]="true"
      [legend]="false"
      [showXAxisLabel]="true"
      [showYAxisLabel]="true"
      xAxisLabel="Completion Percentage"
      yAxisLabel="Number of Projects"
      [barPadding]="20"
      [maxXAxisTickLength]="16"
      [xAxisTickFormatting]="xAxisTickFormatting"
      [scheme]="colorScheme"
      [roundDomains]="true">
    </ngx-charts-bar-vertical>
  </div>
  <div class="section-title">{{ currentWorkingProjectData.inFlightProjectsCount }} In-flight Projects that are on average {{ currentWorkingProjectData.averageCompletion }}% Complete</div>
</div>
